import { HttpClient } from '@angular/common/http';
import { Component, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, takeUntil } from 'rxjs';
import { HomeService } from 'src/app/feature/user/services/home/home.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { Country } from 'src/app/shared/country.type';
import * as formMockDetails from 'src/app/feature/user/services/home/caseCreationDetails.json'
import { TranslateService } from '@ngx-translate/core';
import { AppUtil } from 'src/app/core/utils/utils';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { config } from 'src/assets/config/config';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss']
})
export class RequestFormComponent {
  public serverError = false;
  public featureList: Array<any>;
  public helpfulLinksList: Array<any>;
  private unsubscribe$ = new Subject();
  public createUser = false;
  public locationData: any;
  public locationIp: any;
  public locationCountry: any;
  public selectedFiles: File[] = [];
  public selectedFileNames: string = "No File Chosen";
  public requestForm: FormGroup;
  public submitted: boolean = false;
  public isFileSizeExceeded: boolean = false;
  isUploading: boolean = false;
  public showValidation: boolean = false;
  public formData: any;
  public fileErrorMessage: string = "";
  public serverErrormessage: string;
  userType: any;
  public reasonList: any = [];
  public reasonForContact = "";
  public caseType: any
  public subReasonList: any = [];
  public reasonListObj: any
  public subReason = "";
  public type = "";
  public reason = "";
  public recordTypeId: any;
  public subReasonDefault = ''
  public caseSubmitted = false;;
  public serverSuccessmessage: string;
  public attachmentErrorMessage: string;
  public attachmentSuccessmessage: string;
  public subReasonListObj: any;
  public formDefaultDetails: any;
  public formTitle = ''
  private currentLang: any;
  public formConfigurations: any = []
  public additionalFieldsNeeded= []
  createdCaseNumber = '';
  public userDetails = {
    "customerUserID": "",
    "emailID": "",
    "lastName": "",
    "firstName": "",
    "name": "",
    "phoneNumber": "",
    "total_channel_identifier": "",
    "companyName": "",
    "access_token": '',
    "drift_token": '',
    "id_token": ''
  }
  fileList: any = [];
  public formFields: any[] = [];
  public formType: any;
  attachmentNeeded: boolean = false;
  public successMsgContent: any = [];
  public miscellaneousFields: any = [];
  public RequestUserToFillFormTxt: boolean = false;
  public completeTheFormWithTitle: boolean = false;

  public countryId: any;
  constructor(
    public homeService: HomeService,
    private router: Router,
    public http: HttpClient,
    public formBuilder: FormBuilder,
    private translateService: TranslateService,
    private ngxService: NgxUiLoaderService,
    private sharedService: SharedService,
    private commonService: CommonService
  ) {
    this.requestForm = this.formBuilder.group({});
    this.determineFormType()
    this.initializeFormFields();
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    this.userType = (currentUrl.includes('/private')) ? 'Private' : (currentUrl.includes('/business')) ? 'Business' :
    (currentUrl.includes('/non-customer')) ? 'NonCustomer' : '';
    this.countryId = this.commonService.getCountryId();
    sessionStorage.setItem('userType', this.userType);
    this.formDefaultDetails = formMockDetails;
    let country = sessionStorage.getItem('country');
    if(country == 'sweden')
    this.mockdata()
 
    this.commonService.language$.subscribe(lang => {
    this.currentLang = lang
    if(this.userType)
      this.getHomeDataTask(this.currentLang, this.userType);
    })
    this.initializeFormFields();
    this.getHomeDataTask();
    // this.commonService.getReason().subscribe(
    //   (data) => {
    //     if (data) {
    //       this.reasonListObj = data?.ReasonList;
    //       this.reasonList = Object.keys(data?.ReasonList);
    //       console.log('reasonList1', this.reasonList)
    //       this.subReasonListObj =  data?.SubReasonList;
    //       this.mockdata()

    //   }
    // }
    // );
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fields']) {
      this.initializeFormFields();
    }
  }
  /**
     * @description Method to determine which form type to use
     * 1. if there is only 1 form, then use that form
     * 2. if there is more than one form, based on path private or business load the form
     * If there is any issue with path it will load the default form.
     */

  private determineFormType(): void {
    let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    const regionConfig = config[country];
    const formKeys = Object.keys(regionConfig.forms);
    if (formKeys.length === 1) {
        this.formType = formKeys[0];
    } else if (formKeys.length > 1) {
        const currentPath = this.router.url;
        if (currentPath.includes('/business')) {
            this.formType = 'formFieldsBusiness';
        } else if (currentPath.includes('/private')) {
            this.formType = 'formFieldsPrivate';
        } else if (currentPath.includes('/non-customer')) {
          this.formType = 'formFieldsNonCustomer';
      } else {
            console.warn(`Unknown path: ${currentPath}. Defaulting to first form.`);
            this.formType = formKeys[0];
        }
    }
}

private initializeFormFields(): void {
  let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
  const formConfig: any = config[country].forms;
  const formConfigType = formConfig[this.formType];
  this.formConfigurations = formConfigType;
  this.successMsgContent = (formConfig?.successPage && formConfig.successPage?.[this.formType]) ? formConfig["successPage"][this.formType] : [];
  this.additionalFieldsNeeded = []
  this.miscellaneousFields = (formConfig && formConfig?.miscellaneous && formConfig.miscellaneous?.[this.formType]) ? formConfig.miscellaneous[this.formType] : [];
 this.RequestUserToFillFormTxt = (formConfig && formConfig?.miscellaneous && formConfig.miscellaneous?.RequestUserToFillFormTxt) ? formConfig.miscellaneous.RequestUserToFillFormTxt : false;
 this.completeTheFormWithTitle = (formConfig && formConfig?.miscellaneous && formConfig.miscellaneous?.completeTheFormWithTitle) ? formConfig.miscellaneous.completeTheFormWithTitle : false;
 if(formConfig?.additionalFields)
  formConfig["additionalFields"].forEach((field:any) => {
    if(field[this.formType]) {
      this.additionalFieldsNeeded = field[this.formType];
  }}
  );
  if (!formConfigType) {
    this.formType = Object.keys(config[country].forms)[0] // to avoid error when form type is not present, it will take first form type.
    return; // Or handle this case differently, e.g., show an error message
  }
   Object.keys(this.requestForm.controls).forEach(key => {
    this.requestForm.removeControl(key);
  });
  this.formFields = [];
  formConfigType.forEach((field:any) => {
    if(field?.name) {
    if(field?.mandatory == true) {
    if(field?.name == 'email') {
      this.requestForm.addControl(field.name, new FormControl('', [Validators.required, Validators.email]));
    } else if(field.type == 'file') {
      this.requestForm.addControl(field.name, new FormControl('', [Validators.required, this.fileValidator()]));
    } else {
      this.requestForm.addControl(field.name, new FormControl('', Validators.required));
    }
    this.formFields.push(field);
    } else if(field?.mandatory == false) {
    this.requestForm.addControl(field.name, new FormControl(''));
    this.formFields.push(field);
    }
    this.storeValuesToAutopopulate(field)
    }
  });
}

 public storeValuesToAutopopulate(field: any) {
  let userDetails: any = localStorage.getItem(this.countryId+'_user');
  let userDetailsObj = JSON.parse(userDetails);
  if (userDetailsObj && typeof userDetailsObj === 'object' && Object.keys(userDetailsObj).length > 0) {
  switch(field?.name) {
    case 'name' :
    if (userDetailsObj["firstName"]) {
      this.requestForm.get('name')?.setValue(userDetailsObj["firstName"])
    }
    break;
    case 'email' :
    if (userDetailsObj["emailID"]) {
      this.requestForm.get('email')?.setValue(userDetailsObj["emailID"])
    }  
    break;
    case 'companyName':
      if (userDetailsObj["companyName"]) {
        this.requestForm.get('companyName')?.setValue(userDetailsObj["companyName"])
      }   
    break;
    case 'reasonforContact':
        this.requestForm.get('reasonforContact')?.setValue(this.reasonForContact) 
    break;
    case 'subReason':
        this.requestForm.get('subReason')?.setValue(this.subReason) 
    break;
  }
  }
 }
  /**
  * @description Method to call and map reason and sub-reason, formTitle only
  */
  public getHomeDataTask(lang?: string, userType?: string): void {
    this.homeService.getHomeData(lang, userType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resp) => {
        if (resp) {
          this.featureList = resp?.featureList[0]?.Channel_List;
          this.helpfulLinksList = resp?.helpfulLinksList[0]?.Channel_List;
        }
      },
        (err) => {
          if (err?.error?.StatusCode === "500") {
            this.serverError = true;
          }
        });
  }
  get f() {
    return this.requestForm.controls;
  }


  public mockdata() {
    let selectedChannelMapping: any = {}
    selectedChannelMapping = sessionStorage.getItem('formHeader');
    let title = selectedChannelMapping?.data
    selectedChannelMapping = JSON.parse(selectedChannelMapping);

    this.formTitle = title
    let formTitleMatch: string = ''

    if (selectedChannelMapping?.data?.hasSubreason) {
      formTitleMatch = selectedChannelMapping?.data?.subreason;
    } else {
      formTitleMatch = selectedChannelMapping?.data?.subreason || selectedChannelMapping?.data?.reason;
    }
    this.formDefaultDetails?.mockList.forEach((data: any) => {
      if (data?.dykTitle == formTitleMatch) {
        this.formTitle = data?.formTitle;
        this.reasonForContact = data?.caseReason;
        this.requestForm.get('reasonForContact')?.setValue(this.reasonForContact)
        let index = 0;
        for (const property in this.reasonListObj) {
          if (property == data?.caseReason) {
            index = this.reasonListObj[property]
          }
        }
        this.subReason = data?.subReason;
        this.subReasonList = (this.subReasonListObj) ? this.subReasonListObj[index] : [];

      }
    })
  }
  // subReasonRemoveValue() {
  //   this.subReason = '';
  // }
  // changeSelectedReason(data: any, callTime?: string) {
  //   if (data) {
  //     this.reasonForContact = data;
  //     // this.subReason = '';
  //     let index = 0;
  //     for (const property in this.reasonListObj) {
  //       if (property == data) {
  //         index = this.reasonListObj[property]
  //       }
  //     }
  //     this.subReasonList = this.subReasonListObj[index];
  //   }

  // }
  // public changeSelectedSubReason(data: any) {
  //   if (data) {
  //     this.subReason = data;
  //   }
  // }
 
  onRequestSubmit() {
    this.submitted = true;
    //this.serverErrormessage = "Please try later !";
    // this.serverSuccessmessage = "Case has been created succesfully!"
    if (this.requestForm.invalid) {
      this.showValidation = true;
      return;
    }else {
      let caseType: any = sessionStorage.getItem("caseType")
      this.caseType = sessionStorage.getItem("caseType") ? JSON.parse(caseType) : "";
      const reasonForContactValue = sessionStorage.getItem("sfdc_caseReason");
      this.reasonForContact = reasonForContactValue ? JSON.parse(reasonForContactValue) : "";
      const subReasonValue = sessionStorage.getItem("subReason");
      this.subReason = subReasonValue ? JSON.parse(subReasonValue) : "";
      const typeValue = sessionStorage.getItem("type");
      this.type = typeValue ? JSON.parse(typeValue) : "";
      const reasonValue = sessionStorage.getItem("reason");
      this.reason = reasonValue ? JSON.parse(reasonValue) : "";
      const recordTypeIdVal = sessionStorage.getItem("recordTypeId");
      this.recordTypeId = recordTypeIdVal ? JSON.parse(recordTypeIdVal) : ""

      this.formData = this.requestForm.value;
      this.formConfigurations.forEach((field: any) => {
        if(field?.type == 'date') {
          this.formatDateAsPerRequirement(field)
        }
      })
      this.addAdditionalFieldsBeforeSubmitting()
      this.ngxService.start();
      this.formData.userType = this.userType;
      let userContactDetails: any = localStorage.getItem(this.countryId+"_userContactDetails")
      userContactDetails = JSON.parse(userContactDetails);
      //  this.formData.contactId = (userContactDetails?.id) ? userContactDetails?.id : "";
      this.homeService.submitCaseCreation(this.formData).subscribe(res => {
        let caseId = res?.caseId;
        this.createdCaseNumber = res?.caseNumber;
        //  this.showLoader=false;
        if (res) {
          if (this.fileList.length > 0) {
            this.ngxService.start();
            this.homeService.addAttachmentForCaseCreation(this.fileList, caseId).subscribe(res => {
              this.ngxService.stop();
              if (res) {
                window.scroll(0, 0);
                this.fileList = [];
                this.selectedFiles = []
                this.caseSubmitted = true;
                this.attachmentErrorMessage = ''
                this.attachmentSuccessmessage = this.translateService.instant('attachmentSuccessmessage');
                this.serverSuccessmessage = this.translateService.instant('serverSuccessmessage');
                setTimeout(() => {
                  this.attachmentSuccessmessage = "";
                  this.serverSuccessmessage = "";
                }, 8000);
                this.ngxService.stop();
              } else {
                this.caseSubmitted = true;
                window.scroll(0, 0);
                this.attachmentSuccessmessage = '';
                this.attachmentErrorMessage = this.translateService.instant('attachmentErrorMessage');
                this.serverSuccessmessage = this.translateService.instant('serverSuccessmessage');
                setTimeout(() => {
                  this.attachmentErrorMessage = "";
                  this.serverSuccessmessage = "";
                }, 8000);
                this.ngxService.stop();
              }
            }, error => {
              this.caseSubmitted = true;
              window.scroll(0, 0);
              this.fileList = [];
              this.selectedFiles = [];
              this.ngxService.stop();
              this.attachmentSuccessmessage = '';
              this.attachmentErrorMessage = this.translateService.instant('attachmentErrorMessage');
              this.serverSuccessmessage = this.translateService.instant('serverSuccessmessage');
              setTimeout(() => {
                this.attachmentErrorMessage = "";
                this.serverSuccessmessage = "";
              }, 8000);
              this.ngxService.stop();
            })
          } else {
            this.caseSubmitted = true;
            this.ngxService.stop();
            this.serverSuccessmessage = this.translateService.instant('serverSuccessmessage');

          }
        }
      }, err => {
        this.serverErrormessage = this.translateService.instant('serverErrormessage');
        this.serverSuccessmessage = "";
        setTimeout(() => {
          this.serverErrormessage = ""
        }, 8000);

      })
    }
  }

  ngAfterViewInit(): void {
    this.scrollContent();
  }

  addAdditionalFieldsBeforeSubmitting() {
    this.additionalFieldsNeeded.forEach((field: any) => {
      switch(field) {
        case "userType" : 
        let userType = localStorage
        this.formData.userType = userType;
        break;
        case "reasonForContact" : 
        this.formData.reasonForContact = this.reasonForContact;
        break;
        case "subReason" : 
        this.formData.subReason = this.subReason;
        break;
        case "type" : 
        this.formData.type = this.type;
        break;
        case "reason" : 
        this.formData.reason = this.reason;
        break;
        case "recordTypeId" : 
        this.formData.recordTypeId = this.recordTypeId;
        break;
        case "caseType" : 
        this.formData.caseType = this.caseType;
        break;
      }
});
  }
  navigateToPrivate(): void {
		const langParam = this.sharedService.getDefaultCountry();
    let region = sessionStorage.getItem('region')
		const path = `${region}/private`;
		this.router.navigate([path]);
	}
	navigateToBusiness(): void {
		const langParam = this.sharedService.getDefaultCountry();
    let region = sessionStorage.getItem('region')
		const path = `${region}/business`;
		this.router.navigate([path]);
	}
  navigateToNonCustomer() {
    let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    const regionConfig = config[country];
    let region = sessionStorage.getItem('region')
		const path = `${region}/${regionConfig?.paths[1]}`;
		this.router.navigate([path]);
  }
  navigateToFirstPage() {
    let region = sessionStorage.getItem('region')
		const path = `${region}`;
		this.router.navigate([path]);
  }
  /**
   * Method to scroll the page to the create user form
   */
  public scrollContent(): void {
    const el: any = document.getElementById("create-user");
    el?.scrollIntoView();
  }
  /**
   * Method to clear notification message in form
   */
  public clearMessage(): void {
    this.serverErrormessage = "";
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.fileErrorMessage = "";
    if (inputElement.files && inputElement.files.length > 0) {
      const newFiles = Array.from(inputElement.files);
      const combinedFiles = [...this.selectedFiles, ...newFiles];
      const uniqueFiles = combinedFiles.filter((file, index, self) => 
        index === self.findIndex((f) => f.name === file.name && f.size === file.size)
      );
      const totalSize = uniqueFiles.reduce((acc, file) => acc + file.size, 0);
      const validTypes = ['txt', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'csv', 'gif'];
      // if (uniqueFiles.length < combinedFiles.length) {
      //   this.fileErrorMessage = this.translateService.instant('requestForm.attachmentDuplicationErr');
      // } else 
      if (uniqueFiles.length > 5) {
        //  const controlName = 'attachments';  // You can set this dynamically based on your logic
        //  this.requestForm.get(controlName)?.disable();
        this.fileErrorMessage = this.translateService.instant('requestForm.attachmentCountErr');
      } else if (totalSize > 10 * 1024 * 1024) {
        this.fileErrorMessage = this.translateService.instant('requestForm.attachmentFileSizeErr');
      } else if (uniqueFiles.some(file => {
        const fileExtension = file.name.split('.').pop();
        return !fileExtension || !validTypes.includes(fileExtension?.toLowerCase());
      })) {
        this.fileErrorMessage = this.translateService.instant('requestForm.attachmentTypeErr');
      } else {
        this.selectedFiles = uniqueFiles;
        this.selectedFileNames = this.selectedFiles.map(file => file.name).join(', ');
        this.fileList = [];
        for (let i = 0; i < this.selectedFiles.length; i++) {
          let obj: any = {};
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFiles[i]);
          reader.onload = () => {
            var res: any = reader.result;
            var base64result = res.split(',')[1];
            obj["base64File"] = base64result;
          };
          obj["fileName"] = this.selectedFiles[i]['name'];
          this.fileList.push(obj);
        }
      }
      setTimeout(() => {
        inputElement.value = "";
      }, 0);
    }
  }
  getTotalFileSize(): number {
    return this.selectedFiles.reduce((acc, file) => acc + file.size, 0);
  }
  
  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.fileList.splice(index, 1);
    this.fileErrorMessage = '';
  }

  clearErrMsg(){
    this.fileErrorMessage = '';
  }

  updateSelectedFileNames() {
    this.selectedFileNames = this.selectedFiles.map(file => file.name).join(', ');
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    sessionStorage.removeItem("formHeader");
  } 


  formatDateAsPerRequirement(field: any) {
    if (event) {
        if(this.formData[field.name] !== undefined) {
          const date = new Date(this.formData[field.name]);
          const day = ("0" + date.getDate()).slice(-2);
          const month = ("0" + (date.getMonth() + 1)).slice(-2);
          const year = date.getFullYear();
          let formattedDate = "";
          switch(field?.format) {
            case "dd.mm.yyyy":
              formattedDate =  `${day}.${month}.${year}`;
          }
          this.formData[field.name] = formattedDate;
        }
    }
  }
  
   fileValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Check if the control is an array and if it has at least one file
      if (control && control.value && control.value.length > 0) {
        return null; // Valid
      }
      return { fileRequired: true }; // Invalid if no files are selected
    };
  }
}
